import { ApiPost } from "../../../../services/api/requestJson";

export async function createWorkPlaceRate(payload, toast) {
  return await ApiPost("/api/work-place-rate-list-create/", payload, { toast });
}

export async function addWorkPlaceRates(rates, toast) {
  let result = null;
  for (const rate of rates) {
    result = await createWorkPlaceRate(rate, toast);
  }
  return result;
}
